import { render, staticRenderFns } from "./DoingMoreWithData.vue?vue&type=template&id=867b4324&"
import script from "./DoingMoreWithData.vue?vue&type=script&lang=js&"
export * from "./DoingMoreWithData.vue?vue&type=script&lang=js&"
import style0 from "./DoingMoreWithData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports